import { render, staticRenderFns } from "./report-sinister.vue?vue&type=template&id=fd169cf6&scoped=true"
import script from "./report-sinister.vue?vue&type=script&lang=js"
export * from "./report-sinister.vue?vue&type=script&lang=js"
import style0 from "./report-sinister.vue?vue&type=style&index=0&id=fd169cf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd169cf6",
  null
  
)

export default component.exports